import Main from './components/main';
import "antd/dist/antd.css";


function App() {
  return (
    <div className="App">
      <Main/>
    </div>
  );
}

export default App;
